export default __webpack_public_path__ + "static/media/SDM.0f7bf326.png";